import { PaletteMode, Components, Theme } from '@mui/material';
import { themePalette } from '../theme.palette';
import dimensions from '../dimensions';

export const MuiDividerTheme = (mode: PaletteMode): Components<Theme>['MuiDivider'] => {
  const { tokens } = themePalette(mode);
  const { spacing } = dimensions;

  return {
    styleOverrides: {
      root: {
        marginTop: spacing(2),
        marginBottom: spacing(2),
        borderBottomWidth: '1px',
        borderColor: tokens.stroke.neutral[4],
      },
      vertical: {
        margin: '0 8px',
        height: 'auto',
        borderLeftWidth: '1px',
        borderRightWidth: 0,
        borderBottomWidth: 0,
      },
    },
  };
};
